import { useCallback } from 'react';
import { Criterion, CriterionListItem, FieldChoice } from '@app/api';
import { divideQuotas } from 'lib/criterionQuotaUtils';

export const useAddQuotaButtonHandlerField = ({
  hasQuotas,
  onChoicesChange,
  choices,
  onCriterionChange,
  criterion,
  numberOfParticipantRequired,
}: {
  hasQuotas: boolean;
  onChoicesChange: (choices: FieldChoice[]) => void;
  choices: FieldChoice[];
  onCriterionChange?: (criterion: Criterion) => void;
  criterion?: Criterion | undefined;
  numberOfParticipantRequired?: number;
}) => {
  return useCallback(() => {
    if (hasQuotas) {
      onChoicesChange(
        choices.map((choice: FieldChoice) => ({ ...choice, quota: null })),
      );
      criterion &&
        onCriterionChange &&
        onCriterionChange({ ...criterion, quotas: null });
    } else {
      const divided = divideQuotas(
        numberOfParticipantRequired ?? 0,
        criterion?.allowList?.length ?? 0,
      );

      onChoicesChange(
        choices.map((choice: FieldChoice, index: number) => ({
          ...choice,
          quota: divided[index] ?? 0,
        })),
      );

      criterion &&
        onCriterionChange &&
        onCriterionChange({
          ...criterion,
          quotas: criterion.allowList?.map((field: CriterionListItem) => {
            return {
              item: field,
              value: divided.shift() ?? 0,
              ref: criterion.fieldRef,
            };
          }),
        });
    }
  }, [
    hasQuotas,
    onChoicesChange,
    choices,
    onCriterionChange,
    criterion,
    numberOfParticipantRequired,
  ]);
};
